/* eslint-disable import/prefer-default-export */
import { computed, ref } from 'vue';
import { denomination } from 'config';

/**
 * * Transforms denomination
 * @param {number} n
 */
const toOption = (n) => ({ id: n.toString(), text: `$${n}` });
const giftCardOptions = denomination.map(toOption);

export const useGiftBasic = () => {
  const selectedGift = ref('');

  const giftOptions = computed(() => giftCardOptions);

  return {
    selectedGift,
    giftOptions,
  };
};
